import { strings } from '@goodfynd/strings';
import { dateUtil } from 'utils/index';
import { z } from 'zod';

export const operatingDaysValidation = z.object({
  dates: z.array(z.date()).min(1, 'Choose at least one date to continue.'),
});

export const operatingLocationValidation = z.object({
  location: z.object({
    city: z.string(),
    name: z.string().optional(),
    state: z.string(),
    postalCode: z.string().optional(),
    address: z.string(),
    coordinates: z.string(),
    latitude: z.number(),
    longitude: z.number(),
  }),
});

export const operatingHoursValidation = z
  .object({
    start: z.date({
      invalid_type_error: 'Invalid date/time',
      required_error: strings.validations.startTimeRequired,
    }),
    end: z.date({
      invalid_type_error: 'Invalid date/time',
      required_error: strings.validations.endTimeRequired,
    }),
  })
  .refine(
    (data) => {
      if (data.start && data.end) {
        return data.end > dateUtil.addMinutes(data.start, 1);
      }
      return true;
    },
    {
      message: 'End time must be after start time',
      path: ['end'],
    }
  );

export const orderingValidation = z.object({
  isPrivate: z.boolean().optional(),
  menuId: z.string().optional(),
  pickupCapacity: z.number().optional(),
  pickupCapacityOption: z
    .object({ value: z.union([z.string(), z.number()]) })
    .optional(),
  taxPercent: z.number().optional(),
  taxPercentOption: z
    .object({ value: z.union([z.string(), z.number()]) })
    .optional(),
});
